<template>
  <b-container class="search-area" fluid="lg">
    <b-form-row class="mb-5">
      <b-col cols="4" class="form-group">
        <h3 class="common__search-title">Mail Template name</h3>
        <input v-model="name" type="text" class="form-control w-75" />
      </b-col>
      <b-col cols="4" class="form-group">
        <h3 class="common__search-title">Universiy</h3>
        <SelectUniversityInput
          v-model="university"
          class="form-control w-75"
        />
      </b-col>
      <b-col cols="4">
        <h3 class="common__search-title">Target</h3>
        <label class="checkbox mr-3" v-for="(name, type) of mailTargets" :key="type">
          <input type="checkbox" v-model="targets" :value="type" />
          {{ name }}
        </label>
      </b-col>
    </b-form-row>
    <div class="d-flex justify-content-end">
      <b-button pill variant="secondary" @click="reset" class="mr-2" >
        Reset
      </b-button>
      <b-button pill variant="primary" @click="search">
        Search
      </b-button>
    </div>
  </b-container>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import _ from 'lodash'
import SelectUniversityInput from '@/components/parts/inputItem/SelectUniversityInput.vue'
import { MailTargets, mailTargetType } from '@/store/mails/types'
import { MailTemplateConditions } from '@/store/mails/templates/types'
import { University } from '@/store/master/types'

@Component({
  components: {
    SelectUniversityInput,
  },
})
export default class MailTemplateSearchConditions extends Vue {
  @Prop() value!: MailTemplateConditions|null

  private mailTargets = MailTargets

  private name: string = ''

  private university: University|null = null

  private targets: mailTargetType[] = []

  private search(): void {
    const conditions: MailTemplateConditions = {
      name: this.name,
      university: this.university,
      targets: this.targets,
    }
    this.$emit('changeConditions', conditions)
  }

  private reset(): void {
    this.name = ''
    this.university = null
    this.targets = []
    this.search()
  }
}
</script>

<style scoped>
</style>
